require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-manage-a-book-trading-club.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-manage-a-book-trading-club");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-manage-a-book-trading-club!./.cache/json/coding-interview-prep-take-home-projects-manage-a-book-trading-club.json
// module id = 1931
// module chunks = 231608221292675